export default "__VITE_ASSET__c8443669__"